import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { zDayJs } from '@/lib/schema/v2/dayjs'

export const notificationSettingSchema = z.object({
    created_at: zDayJs,
    is_enabled: z.boolean(),
    type_uuid: z.uuid(),
    updated_at: zDayJs,
    user_type: z.string(),
    user_uuid: z.uuid(),
    uuid: z.uuid(),
})

export const notificationSettingsSchema = z.array(notificationSettingSchema)

export const paginatedNotificationSettingsSchema = z.object({
    data: notificationSettingsSchema,
    links: paginationLinksSchema,
    meta: paginationMetaSchema,
})

export type NotificationSetting = z.infer<typeof notificationSettingSchema>
export type NotificationSettings = z.infer<typeof notificationSettingsSchema>
